import React from "react";
import ProjectRow from "./ProjectRow";

function ProjectsTable({ projects, onNavigate }) {
  return (
    <table className="data-table">
      <thead>
        <tr>
          <th scope="col">Projeto</th>
          <th scope="col" className="col-type">
            Tipo
          </th>
          <th scope="col" className="col-situation">
            Situação
          </th>
          <th scope="col" className="col-status">
            Status
          </th>
          <th scope="col" className="col-coordinator">
            Coordenador
          </th>
          <th scope="col" className="col-upd">
            Atualizado
          </th>
          <th scope="col" className="col-go">
            <span className="sr-only">Abrir</span>
          </th>
        </tr>
      </thead>

      <tbody>
        {projects.map((project) => (
          <ProjectRow key={project.id} project={project} onNavigate={onNavigate} />
        ))}
      </tbody>
    </table>
  );
}

export default ProjectsTable;
